import { r as registerInstance, h, F as Fragment, g as getElement } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { i as isV3 } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { c as comparator, M as MAX_COMPARATOR_ITEMS, g as getComparisonSessionId } from './comparator-188d64f5.js';
import './_commonjsHelpers-ba3f0406.js';
import './analytics-765d4daf.js';
import './utils-15ad90ec.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

// Used in pes-comparison-bar button to navigate to comparator page
const REPLATFORMED_COMPARATOR_URL = '/v3/product-comparator';

const comparisonBarCss = "@keyframes pulse{0%{transform:scale(1)}50%{transform:scale(1.03)}100%{transform:scale(1)}}:host{box-sizing:border-box;display:block;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}.comparison-bar__container{background:#ffd100;height:0;overflow:hidden;transition:height 0.25s cubic-bezier(0, 0, 0.6, 1);font-size:0.875rem;color:#333333}@media screen and (min-width: 720px){.comparison-bar__container{margin-bottom:-12px;margin-top:12px}}.comparison-bar__container--hidden{height:0}@media screen and (max-width: 979px){.comparison-bar__container--visible{height:48px}}@media screen and (min-width: 980px){.comparison-bar__container--visible{height:56px}}.comparison-bar__container--is-animating{animation:pulse 0.25s;animation-iteration-count:1}.comparison__bar{position:relative;overflow:hidden;display:flex;flex-direction:row;align-items:center}@media screen and (max-width: 979px){.comparison__bar{height:48px}}@media screen and (min-width: 980px){.comparison__bar{height:56px;justify-content:space-between}:host(:not([dir=\"rtl\"])) .comparison__bar{padding-left:130px;padding-right:72px}:host([dir=\"rtl\"]) .comparison__bar{padding-right:130px;padding-left:72px}}.comparison__info{display:flex;align-items:center}.compare__info{display:inline-flex;flex-direction:row;align-items:center}:host(:not([dir=\"rtl\"])) .compare__info{margin-right:32px}:host([dir=\"rtl\"]) .compare__info{margin-left:32px}:host(:not([dir=\"rtl\"])) .compare__info-label{margin-right:4px}:host([dir=\"rtl\"]) .compare__info-label{margin-left:4px}.compare_qty{display:inline-flex}.compare__clear-btn{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;color:#333333;display:inline-flex;align-items:center;transition:color 0.25s}:host(:not([dir=\"rtl\"])) .compare__clear-btn{margin-right:32px}:host([dir=\"rtl\"]) .compare__clear-btn{margin-left:32px}.compare__clear-btn:hover{color:#0f0f0f}.compare__clear-btn:hover .compare__clear-label{text-decoration:underline}:host(:not([dir=\"rtl\"])) .compare__clear-icon{margin-right:10px}:host([dir=\"rtl\"]) .compare__clear-icon{margin-left:10px}.comparison__link{display:none;display:block;color:#333333;border:1px solid currentColor;border-radius:2px;padding:6px 16px;text-decoration:none;transition:all 0.25s}.comparison__link:hover,.comparison__link:focus,.comparison__link:active{box-shadow:0 0 0 1px #333333}.comparison__link--mobile{flex:1 1 auto;color:#333333;text-decoration:none;padding:16px 18px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.comparison__link--mobile:hover{background:#e6bc00}.compare__clear-label--mobile{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;color:#333333;padding:12px 14px;transition:all 0.25s}:host(:not([dir=\"rtl\"])) .compare__clear-label--mobile{border-left:1px solid rgba(51, 51, 51, 0.3)}:host([dir=\"rtl\"]) .compare__clear-label--mobile{border-right:1px solid rgba(51, 51, 51, 0.3)}.compare__clear-label--mobile:hover{color:#0f0f0f;background:#e6bc00}";

const COMPARATOR_URL = '/product-comparator';
const DESKTOP_WIDGET_HEIGHT = 56;
const MOBILE_WIDGET_HEIGHT = 48;
let ComparisonBar = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isPublic = false;
    this.isConfigured = false;
    this.compareQuantity = comparator.getStoredProductIds().length;
    this.compareLimit = MAX_COMPARATOR_ITEMS;
    this.clearItems = () => {
      comparator.removeAll();
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleCompareQuantityChange(newQty, oldQty) {
    if (oldQty === 0) {
      return;
    }
    if (newQty > 0) {
      this.animateQuantityChange();
    }
  }
  handleDocumentUpdate() {
    if (this.isShown()) {
      const paddingBottom = this.isMobile ? MOBILE_WIDGET_HEIGHT : DESKTOP_WIDGET_HEIGHT;
      document.body.style.paddingBottom = `${paddingBottom}px`;
    }
    else {
      document.body.style.paddingBottom = '';
    }
  }
  handleComparatorProductsChange() {
    this.compareQuantity = comparator.getStoredProductIds().length;
  }
  animateQuantityChange() {
    if (this.comparisonBarEl) {
      const animationClassName = 'comparison-bar__container--is-animating';
      const removeAnimationHandler = () => {
        this.comparisonBarEl.classList.remove(animationClassName);
        this.comparisonBarEl.removeEventListener('animationend', removeAnimationHandler);
      };
      this.comparisonBarEl.classList.add(animationClassName);
      this.comparisonBarEl.addEventListener('animationend', removeAnimationHandler);
    }
  }
  comparisonUrl() {
    const url = `${this.localeCode}${isV3() && !this.isPublic ? REPLATFORMED_COMPARATOR_URL : COMPARATOR_URL}`;
    const productIds = comparator.getStoredProductIds().join('|');
    return `${url}/${getComparisonSessionId()}/${productIds}`;
  }
  renderCompareQuantity() {
    return h("div", { class: "compare_qty" }, this.compareQuantity);
  }
  isShown() {
    return this.isConfigured && this.compareQuantity > 0;
  }
  renderDesktop() {
    return (h(Fragment, null, h("div", { class: "comparison__info" }, h("div", { class: "compare__info" }, h("div", { class: "compare__info-label" }, this.compareLabel), this.renderCompareQuantity()), h("button", { class: "compare__clear-btn", onClick: this.clearItems }, h("pes-icon", { class: "compare__clear-icon" }, "action_delete"), h("span", { class: "compare__clear-label" }, this.clearListLabel))), h("div", { class: "comparison__cta" }, h("a", { href: this.comparisonUrl(), class: "comparison__link" }, this.compareCta))));
  }
  renderMobile() {
    return (h(Fragment, null, h("a", { class: "comparison__link--mobile", href: this.comparisonUrl() }, this.compareLabel, " ", this.renderCompareQuantity()), h("button", { class: "compare__clear-label--mobile", onClick: this.clearItems }, h("pes-icon", null, "action_delete"))));
  }
  render() {
    return (h("div", { ref: (el) => (this.comparisonBarEl = el), class: classnames('comparison-bar__container', this.isShown()
        ? 'comparison-bar__container--visible'
        : 'comparison-bar__container--hidden') }, h("div", { class: "comparison__bar" }, this.isMobile ? this.renderMobile() : this.renderDesktop())));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "compareQuantity": ["handleCompareQuantityChange", "handleDocumentUpdate"],
    "isMobile": ["handleDocumentUpdate"],
    "isConfigured": ["handleDocumentUpdate"]
  }; }
};
ComparisonBar.style = comparisonBarCss;

export { ComparisonBar as pes_comparison_bar };
